// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IEndOfCoveragePropertyDto
 */
export interface IEndOfCoveragePropertyDto {
    /**
     * 
     * @type {number}
     * @memberof IEndOfCoveragePropertyDto
     */
    end_of_coverage_days_amount?: number;
    /**
     * 
     * @type {string}
     * @memberof IEndOfCoveragePropertyDto
     */
    end_of_coverage_type?: IEndOfCoveragePropertyDtoEndOfCoverageTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IEndOfCoveragePropertyDto
     */
    end_of_coverage_state?: IEndOfCoveragePropertyDtoEndOfCoverageStateEnum;
}

/**
* @export
* @enum {string}
*/
export enum IEndOfCoveragePropertyDtoEndOfCoverageTypeEnum {
    DO_NOTHING = 'DO_NOTHING',
    DAY_OF_TERMINATION = 'DAY_OF_TERMINATION',
    FIRST_DAY_FOLLOWING_MONTH = 'FIRST_DAY_FOLLOWING_MONTH',
    CUSTOM = 'CUSTOM'
}
/**
* @export
* @enum {string}
*/
export enum IEndOfCoveragePropertyDtoEndOfCoverageStateEnum {
    MODIFIABLE = 'MODIFIABLE',
    LOCKED = 'LOCKED',
    HIDDEN = 'HIDDEN',
    REQUIRED_AT_PLAN = 'REQUIRED_AT_PLAN',
    REQUIRED_AT_ALL_LEVELS = 'REQUIRED_AT_ALL_LEVELS'
}


/**
 * Check if a given object implements the IEndOfCoveragePropertyDto interface.
 */
export function instanceOfIEndOfCoveragePropertyDto(value: object): value is IEndOfCoveragePropertyDto {
    return true;
}

export function IEndOfCoveragePropertyDtoFromJSON(json: any): IEndOfCoveragePropertyDto {
    return IEndOfCoveragePropertyDtoFromJSONTyped(json, false);
}

export function IEndOfCoveragePropertyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IEndOfCoveragePropertyDto {
    if (json == null) {
        return json;
    }
    return {
        
        'end_of_coverage_days_amount': json['end_of_coverage_days_amount'] == null ? undefined : json['end_of_coverage_days_amount'],
        'end_of_coverage_type': json['end_of_coverage_type'] == null ? undefined : json['end_of_coverage_type'],
        'end_of_coverage_state': json['end_of_coverage_state'] == null ? undefined : json['end_of_coverage_state'],
    };
}

export function IEndOfCoveragePropertyDtoToJSON(json: any): IEndOfCoveragePropertyDto {
    return IEndOfCoveragePropertyDtoToJSONTyped(json, false);
}

export function IEndOfCoveragePropertyDtoToJSONTyped(value?: IEndOfCoveragePropertyDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'end_of_coverage_days_amount': value['end_of_coverage_days_amount'],
        'end_of_coverage_type': value['end_of_coverage_type'],
        'end_of_coverage_state': value['end_of_coverage_state'],
    };
}

